import React from 'react';
import './LayoutFormTree.css'

function LayoutFormTree( { props } ) {

    const header = !props.header ? '' :
        <div className="header">
            { props.header }
        </div>;

    const main = !props.main ? '' :
        <div className="main">
            { props.main }
        </div>;
        
    const formTree = !props.formTree ? '' :
        <div id="formTreeContainer" className="formTree">
            { props.formTree }
        </div>;
        
    const footer = !props.footer ? '' :
        <div className="footer">
            { props.footer }
        </div>;
        
        
    return (
        <div className="LayoutFormTree">

            { header }

            <div className="panel">

                { formTree }
                { main }                

            </div>
            
            { footer }

        </div>
    );
}

export default LayoutFormTree;
